import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50fdd244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat_message_content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head_content" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "left_tips" }, "LINKARD"),
  /*#__PURE__*/_createElementVNode("span", null, "对话记录"),
  /*#__PURE__*/_createElementVNode("div", { class: "right_line" })
], -1))
const _hoisted_3 = { class: "chat-list-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_ChatMessageListItem = _resolveComponent("ChatMessageListItem")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_VideoTriggerPlayView = _resolveComponent("VideoTriggerPlayView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_image, {
      class: "back_action",
      src: require('../assets/image/white_btn_icon.svg'),
      onClick: _ctx.close
    }, null, 8, ["src", "onClick"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_list, { finished: true }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_cell, { key: index }, {
              default: _withCtx(() => [
                _createVNode(_component_ChatMessageListItem, {
                  isUmi: item.fromBot,
                  text: item.text,
                  sourceType: _ctx.sourceType,
                  triggerType: item.triggerType,
                  fromAudio: item.fromAudio,
                  mediaUrl: item.mediaUrl,
                  url: item.url,
                  npcName: _ctx.npcName,
                  onDismissVideoTriggerPlayView: _ctx.dismissVideoTriggerPlayView,
                  onShowVideoPaly: _ctx.showVideoPaly
                }, null, 8, ["isUmi", "text", "sourceType", "triggerType", "fromAudio", "mediaUrl", "url", "npcName", "onDismissVideoTriggerPlayView", "onShowVideoPaly"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    (_ctx.showVideoPlayTriggerView)
      ? (_openBlock(), _createBlock(_component_VideoTriggerPlayView, {
          key: 0,
          onDismissVideoTriggerPlay: _ctx.dismissVideoTriggerPlayView,
          showVideoUrl: _ctx.showVideoUrl
        }, null, 8, ["onDismissVideoTriggerPlay", "showVideoUrl"]))
      : _createCommentVNode("", true)
  ]))
}